import { compactNumber } from "@cntrl/ui";

/**
 * The card's header line. Recent adds: "15 placements · ranked by recency · 44.1K total reach" — the count and
 * reach of the PLACEMENTS, served (a summary stat is a server count). The vendor fallback carries no placement set,
 * so it keeps the artist's own current reach.
 */
export function playlistHeader(hero: {
  playlistAddsCount?: number | null;
  playlistAddsReach?: number | null;
  playlistReachCurrent?: number | null;
} | null | undefined): string | null {
  if (hero?.playlistAddsCount != null) {
    const n = hero.playlistAddsCount;
    return [
      `${n} placement${n === 1 ? "" : "s"}`,
      "ranked by recency",
      hero.playlistAddsReach ? `${compactNumber(hero.playlistAddsReach)} total reach` : null,
    ].filter(Boolean).join(" · ");
  }
  const reach = hero?.playlistReachCurrent ?? 0;
  return reach > 0 ? `${compactNumber(reach)} total reach` : null;
}
